import { render, staticRenderFns } from "./SilderCard.vue?vue&type=template&id=7a760ec5&"
import script from "./SilderCard.vue?vue&type=script&lang=js&"
export * from "./SilderCard.vue?vue&type=script&lang=js&"
import style0 from "./SilderCard.vue?vue&type=style&index=0&id=7a760ec5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports